// Converts "Himachal Pradesh" -> "himachal-pradesh"
export const slugify = (text) =>
  text
    ?.toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-') // replace spaces with hyphens
    .replace(/[^\w\-]+/g, '') // remove invalid chars
    .replace(/\-\-+/g, '-') || '';

// Converts "himachal-pradesh" -> "Himachal Pradesh"
export const deslugify = (slug) =>
  slug
    ? slug
        .toString()
        .replace(/-/g, ' ') // hyphens back to spaces
        .replace(/\b\w/g, (l) => l.toUpperCase()) // capitalize words
    : '';
